import developers from "../developers";
import tags from "../tags";

// icons
import elmascoffeeIcon from "../../assets/apps/icons/elmascoffee.png";

// images
import elmascoffeeCover from "../../assets/apps/images/elmascoffee/cover.png";
import elmascoffeeImage1 from "../../assets/apps/images/elmascoffee/1.png";
import elmascoffeeImage2 from "../../assets/apps/images/elmascoffee/2.png";
import elmascoffeeImage3 from "../../assets/apps/images/elmascoffee/3.png";
import elmascoffeeImage4 from "../../assets/apps/images/elmascoffee/4.png";
import elmascoffeeImage5 from "../../assets/apps/images/elmascoffee/5.png";
import elmascoffeeImage6 from "../../assets/apps/images/elmascoffee/6.png";
import elmascoffeeImage7 from "../../assets/apps/images/elmascoffee/7.png";

export const elmascoffee = {
    title: "Elmas Coffee WebStore",
    slug: "elmas-coffee-webstore",
    url: "https://elmascoffee.com",
    description: `
### Overview
Elmas Coffee is a modern and elegant online coffee webstore designed to deliver a smooth shopping experience for coffee lovers. The platform showcases a rich selection of coffee products, allowing customers to explore, choose, and purchase their favorite blends easily through a clean and professional interface.

### Purpose & Value
The main goal of Elmas Coffee is to provide a dedicated digital space for high-quality coffee shopping. It connects customers with a variety of coffee options, offering convenience, accessibility, and a refined browsing experience that reflects the premium nature of the brand.

### User Experience & Design
Elmas Coffee focuses heavily on modern aesthetics, simplicity, and user-friendly navigation. The design is crafted to feel warm and inviting, matching the atmosphere of a real coffee shop. With a fully responsive layout, the store delivers a seamless experience across desktops, tablets, and mobile devices.

### Key Features
- Beautiful online storefront for showcasing coffee products  
- Smooth browsing experience with clean product presentation  
- Responsive design optimized for all screen sizes  
- Modern UI that reflects a premium coffee brand identity  
- Structured layout for product discovery and exploration  
- Fast and accessible shopping experience  

---

### Coffee Store Experience

Elmas Coffee provides an enjoyable journey from discovery to purchase:

#### Product Browsing
Customers can explore a variety of coffee types, blends, and offerings through a visually appealing catalog.

#### Coffee Selection
Each product is presented clearly, allowing users to choose the perfect coffee based on taste and preference.

#### Simple Online Shopping
The platform is designed to make ordering coffee easy, providing a smooth and intuitive purchasing flow.

---

### Brand & Lifestyle Focus

Elmas Coffee is more than a store — it represents a lifestyle and passion for coffee. The platform is built to highlight:

- Quality and craftsmanship  
- A premium coffee experience  
- Convenience of online ordering  
- A welcoming and modern brand identity  

---

### Future Growth & Expansion
Elmas Coffee is designed with scalability in mind, allowing for future enhancements such as expanded product collections, customer accounts, promotions, and additional features to enrich the shopping experience.

### Summary
Elmas Coffee is a stylish and responsive online coffee webstore built to bring premium coffee closer to customers. With its modern design, smooth user experience, and strong brand presence, it offers an inviting platform for discovering and enjoying high-quality coffee products anytime, anywhere.
`,

    tags: [
        tags.react,
        tags.mui,
        tags.javascript,
        tags.bootstrap,
        tags.i18next,
        tags.swiper,
        tags.ecommerce,
        tags.search,
        tags.responsive,
        tags.mobileFirst,
        tags.webApp,
    ],
    icon: elmascoffeeIcon,
    cover: elmascoffeeCover,
    badge: "React",
    images: [
        elmascoffeeImage1,
        elmascoffeeImage2,
        elmascoffeeImage3,
        elmascoffeeImage4,
        elmascoffeeImage5,
        elmascoffeeImage6,
        elmascoffeeImage7,
    ],
    github: "",
    developer: developers.bilalabdulhadii,
};
